/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 轮询时间（秒）
 */
export const REMOTE_ASSISTANCE_POLLING_TIME = 15;

/**
 * 远程协助任务状态
 */
export enum RemoteAssistanceTaskStatusE {
    /** 无任务 */
    NOTASK = '0',
    /** 请求等待任务 */
    WAITING = '1',
    /** 正在建立远程协助通道 */
    CONNECTING = '2',
    /** 远程任务运行中 */
    RUNNING = '3',
    /** 正在结束远程协助通道 */
    TERMINATING = '4',
    /** 正在重新链接 */
    RECONNECTION = '5'
}

/**
 * 远程协助处理参数
 */
export enum RemoteAssistanceTaskParamE {
    /** 接受 */
    ACCEPT = '0',
    /** 拒绝 */
    REJECT = '1',
    /** 终止 */
    TERMINATE = '2'
}

/**
 * 1分钟
 */
export const ONE_MINUTE = 1;

/**
 * 接受/关闭的弹窗宽度（极简模式）
 */
export const REMOTE_ASSISTANCE_DIALOG_WIDTH = '4.8rem';

/**
 * 接受/关闭的弹窗内容高度（极简模式）
 */
export const REMOTE_ASSISTANCE_DIALOG_HEIGHT = 'auto';
